import React from "react";

class Input extends React.Component {
  render() {
    return (
      <input
        type="text"
        placeholder="Search for locations"
        value={this.props.search}
        onChange={this.props.handleSearchChange}
      />
    );
  }
}

export default Input;
